<template>
  <div class="apply-info x-margin x-border-50">
    <el-tabs v-model="tabsActive">
      <el-tab-pane :label="$t('HT.userInfo.title')" name="basicInfo">
        <div class="ul-item">
          <div class="info-item">
            <span class="label-title">{{ $t('HT.unbindApply.name') }}</span>
            <span class="info-content">{{ formData.name }}</span>
            <span v-if="$hasModule(2)" class="info-btn" @click="showEdit">{{ $t("HT.edit") }}</span>
          </div>
          <div class="info-item">
            <span class="label-title">{{ $t('HT.createdTime') }}</span>
            <span class="info-content">{{ formData.created_date }}</span>
          </div>
          <div class="info-item">
            <span class="label-title">{{ $t('HT.last.revisiontime') }}</span>
            <span class="info-content">{{ formData.modified_date }}</span>
          </div>
          <div class="info-item">
            <span class="label-title">{{ $t('HT.bindAccessIp.appId') }}</span>
            <span class="info-content">{{ formData.id }}</span>
          </div>
          <div class="info-item">
            <span class="label-title">API Key</span>
            <span class="info-content">{{ formData.app_key }}</span>
          </div>
          <div class="info-item">
            <span class="label-title">Secret Key</span>
            <span class="info-content">{{ show ? formData.app_secret : '***********' }}</span>
            <span class="info-btn" @click="show = !show">{{ show ? $t('HT.hide') : $t('HT.show') }}</span>
            <span v-if="$hasModule(2)" class="info-reset" @click="reset">{{ $t('HT.reset') }}</span>
          </div>
          <div class="info-item">
            <span class="label-title">AppCode</span>
            <span class="info-content">{{ formData.app_code }}</span>
          </div>
          <div class="info-item">
            <span class="label-title">IP白名单</span>
            <div class="info-content whitelist">
              <el-input v-model='formData.ip_white_list' type="textarea" :rows="5" clearable placeholder="非必填，不填表示无IP限制
    添加IP白名单后，只有白名单IP才能调用
    IP设定为服务器出口IP，支持设定IP段，如202.202.2.*
    支持输入多个IP，多IP请换行，每行输入一个IP"></el-input>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="$t('HT.applyInfo.checkedList')" name="selectProduct">
        <div class="ul-item">
          <div class="info-item">
            <span class="label-title">{{ $t('HT.applyInfo.checkedList') }}</span>
            <div class="info-content info-checkbox">
              <div class="checkbox-group" v-for="(item,index) in infoArray" :key="index">
                <div>
                  <div class="check-all">
                    <span class="check-type">{{$t(item.type)}}</span>
                    <el-checkbox v-model="item.flag" :indeterminate="itemIndeterminate(item)"
                      @change="handleCheckAll($event, item)">{{ $t('HT.deviceManage.checkAll') }}</el-checkbox>
                  </div>
                  <el-checkbox-group class="checkbox-group-list" v-model="selectedData"
                    @change="handleChanges(item)">
                    <el-checkbox v-for="product in item.infoList"  :label="product.id" :key="product.id">{{ product.name
                    }}</el-checkbox>
                  </el-checkbox-group>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <div class="footer-btn">
      <ux-button class="save-btn" type="primary" :disabled="tabsActive=='selectProduct'&&disableSaveBtn" @click="saveChange">{{ $t('HT.save')
      }}</ux-button>
      <ux-button v-if="disableSaveBtn" class="return-list" type="primary" plain @click="returnBack(false)">{{
        $t('HT.return.list') }}</ux-button>
      <my-popconfirm v-else width="240px" :title="$t('HT.data.changed')" placement="top" iconColor="#8690AA"
        :confirm-button-text="$t('HT.save')" @onConfirm="returnBack(true)" @onCancel="returnBack(false)">
        <ux-button class="return-list" type="primary" plain slot="reference">{{ $t('HT.return.list') }}</ux-button>
      </my-popconfirm>
    </div>
  </div>
</template>

<script>
import addApply from './template/addApply';
import myPopconfirm from '@c/myPopconfirm/myPopconfirm';

export default {
  components: {
    addApply,
    myPopconfirm
  },
  data() {
    return {
      selectedData:[],
      layout: [
        {
          type: 'select',
          placeholder: this.$t('HT.product'),
          options: [],
          key: 'productName',
          event: 'change',
          props: {
            label: 'name',
            value: 'name'
          }
        },
        {
          type: 'input',
          key: 'uri',
          placeholder: this.$t('HT.applyInfo.uri.placeholder')
        }
      ],
      columns: [
        // 表头数据
        {
          label: this.$t('HT.unbindApi.name'),
          prop: 'product_name',
          tooltip: true
        },
        {
          label: 'URI',
          prop: 'uri',
          tooltip: true
        },
        {
          label: this.$t('HT.applyInfo.remark'),
          prop: 'remark',
          tooltip: true
        },
        {
          label: this.$t('HT.applyInfo.createTime'),
          prop: 'create_time',
          tooltip: true
        },
        {
          label: this.$t('HT.orderManage.status'),
          prop: 'status',
          tooltip: true
        },
        {
          label: this.$t('HT.applyInfo.errorClass'),
          prop: 'error_class',
          tooltip: true
        },
        {
          label: this.$t('HT.applyInfo.errorMsg'),
          prop: 'error_msg',
          tooltip: true
        }
      ],
      show: false,
      id: this.$route.params.id, // 应用列表id
      formData: {}, // 详情数据
      tableData: {
        // 应用日志表格数据
        totalSize: 0,
        list: []
      },
      filter: {
        productName: '',
        productId: '',
        uri: '',
        page: 1,
        size: 10
      },
      checkList: [], // 选中的所有产品
      productList: [], // 所有产品
      disableSaveBtn: false,
      faceTipContent: this.$t('HT.face.tip'),
      tabsActive:'basicInfo',
      infoArray:[]
    };
  },
  created() {
    this.getInfo(this.id).then(() => {
      this.getList();
    });
  },
  methods: {
    // 获取对应产品类型标题
    getProductTitle(val){
      let filterItem =this.productTypesList.filter(item=>{
        return val.type==item.value
      })
     return filterItem[0].label+''
    },
    /**
     * 获取详情
     * @param {Object} params 请求参数
     */
    getInfo(id) {
      return new Promise(resolve => {
        this.$api.apply.getInfo(id).then((res) => {
          if (res.code == 10000) {
            res.data.ip_white_list = res.data.ip_white_list&&res.data.ip_white_list.replaceAll(/,/g, '\n')
            this.formData = res.data;
            this.selectedData=[]
            this.checkList = []
            this.formData.product_authorized.forEach(element => {
              this.selectedData.push(element.id)
              this.checkList.push(element.id)
            });
            this.disableSaveBtn = true;
            this.layout[0]['options'] = this.formData.product_authorized;
            resolve();
          }
        });
      });
    },
    /**
     * 获取列表
     * @param {Object} params 请求参数
     */
    getList() {
      this.$uxLoading.show();
      this.$api.product.getAllProduct().then((res) => {
        if (res.code == 10000) {
          let list = res.data || [];
          let result = [];
          this.productList = result;
          const treeList = this.getTreeList(list)
          // 初始化数据为未选false
          this.infoArray=(treeList).map((v)=>({
            ...v,flag:false
          }))
          // 回显数据
          this.infoArray.forEach((item,index)=>{
            let tempList=item.infoList.map(ite=>ite.id)
            tempList.some((v) => {
                if (this.selectedData.indexOf(v)==-1) {
                  item.flag = false;
                }else{
                  item.flag=true
                }
            });
          })
        }
      });
    },
    // 获取tree数据
    getTreeList(data) {
        let newObj = {}
        data.forEach((item, index) => {
          // 解构出每一个对象里面type字段的值
          let { type } = item
          // 如果在这个新对象里面没有找到，则新增一个对象
          if (!newObj[type]) {
            // 重构对象
            newObj[type] = {
              type,
              infoList: [],
            }
          }
          // 如果在对象里面找到有相同的 type 字段的值，则Push进入children里面
          newObj[type].infoList.push(item)
        })
        let newArr = Object.values(newObj)
        return newArr
      },
    /**
     * 修改列表
     * @param {Number} id 唯一标识
     * @param {Object} params 表单提交参数
     */
    putList(params,flag=true) {
      this.$uxLoading.show();
      this.$api.apply.putList(params).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.editSuccess'));
          flag&&this.getInfo(this.id);
        }
      });
    },

    /**
     * 重置
     * @param {Number} 唯一标识
     */
    reset() {
      let Id = this.id;
      this.$api.apply.reset(Id).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.resetSuccess'));
          this.getInfo(this.id);
        }
      });
    },

    /**
     * 编辑
     */
    showEdit() {
      const title = this.$t('HT.applyInfo.edit');
      this.$uxModal.show({
        title,
        content: (h) => {
          return h(addApply, {
            props: { data: this.formData },
            on: {}
          });
        },
        confirm: (data) => {
          data.ip_white_list = data.ip_white_list&&data.ip_white_list.replace(/[(\r\n)\r\n]+/g, ',')
          this.putList(data);
        }
      });
    },
    // 全选方法
    handleCheckAll(val,item){
      const next=item.infoList.map(item=>item.id)
      const filterArr = this.selectedData.filter(
        (v) => next.indexOf(v) == -1
      );
      this.selectedData= val ? filterArr.concat(next) : filterArr;
      this.disableSaveBtn = this.checkIsChange()
    },
    itemIndeterminate(item) {
      const infoLists=item.infoList.map(ite=>ite.id)
      return (
        infoLists.some((v) => this.selectedData.indexOf(v) > -1) &&
        !infoLists.every((v) => this.selectedData.indexOf(v) > -1)
      );
    },
    // 勾选变化方法
    handleChanges(val){
      const infoLists=val.infoList.map(ite=>ite.id)
      infoLists.some((v) => {
        if (this.selectedData.indexOf(v)>-1) {
          val.flag = true;
        }else{
          val.flag=false
        }
      });
      this.disableSaveBtn = this.checkIsChange()
    },
    // 控制保存按钮显示隐藏
    checkIsChange() {
      let {delArr,addArr} = this.compareArrayDiff(this.selectedData,this.checkList)
      // 删除和新增都没数据，不能点击保存按钮
      return (delArr.length==0&&addArr.length==0)?true:false;
    },
    // 返回列表
    returnBack(isSave) {
      if (isSave) {
        this.saveChange();
      }
      this.$router.push('/applyList');
    },
    // 保存数据
    async saveChange() {
      if(this.tabsActive == 'basicInfo'){
        this.saveBasicInfo()
      }else{
        this.saveSelectProduct()
      }
    },
    async saveBasicInfo(){
      // 后端说页面的提交只是修改产品信息，添加白名单需求掉修改应用信息的接口
      let params=Object.assign({},this.formData);
      params.ip_white_list = params.ip_white_list&&params.ip_white_list.replace(/[(\r\n)\r\n]+/g, ',')
      await this.putList(params,false);
    },
    // 对比前后数组是否有新增和删除数据
    compareArrayDiff(newArr, oldArr) {
      const tNewArr = newArr;
      const tOldArr = oldArr;
      const totalArr = [...new Set(tNewArr.concat(tOldArr))];
      // 新数组 与 全数组比较差异，得到新数组 删掉的项(新数组中不存在，而总数组存在，则是新数组删掉的)
      const delArr = [];
      totalArr.forEach((item) => {
        if (!tNewArr.includes(item)) delArr.push(item);
      });
      // 旧数组 与 全数组比较差异，得到新数组 增加的项(旧数组中不存在，而总数组存在，则是新数组增加的)
      const addArr = [];
      totalArr.forEach((item) => {
        if (!tOldArr.includes(item)) addArr.push(item);
      });
      return {
        delArr,
        addArr,
      };
    },
    saveSelectProduct(){
      this.$uxLoading.show();
      let postData = {
        app_id: this.formData.id, // 应用id
      };
      // 获取新增产品lsit和删除产品list
      let {delArr,addArr} = this.compareArrayDiff(this.selectedData,this.checkList)
      postData.product_ids = addArr.join(',');
      postData.unbind_product_ids = delArr.join(',');
      this.$api.apply.authorization(postData).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.save.success'));
          this.getInfo(this.id);
        }
      });

    }
  }
};
</script>

<style lang="scss">
.apply-info {
  position: relative;
  box-sizing: border-box;
  border-radius: 8px;
  padding: 24px 40px;
  background: #FFFFFF;
  height: 100%;

  .head-title {
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #161E28;
    line-height: 26px;
    padding-bottom: 13px;
    border-bottom: 1px solid #E8ECF2;
  }

  .ul-item {
    padding-top: 43px;
  }

  .info-item {
    display: flex;
    margin-bottom: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 20px;

    .label-title {
      width: 120px;
      color: #5A6482;
      display: inline-block;
    }

    .info-content {
      margin-left: 40px;
      color: #161E28;
    }

    .info-checkbox {
      width: 100%;
      margin-left: 60px;
      max-height: 500px;
      overflow: auto;
      .check-all {
        width: 100%;
        height: 40px;
        background: #E8ECF2;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 20px;
        box-sizing: border-box;

        .check-type {
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #161E28;
        }

        .ux-tooltip {
          margin-left: 10px;
          color: #8690AA;
        }
      }

      .checkbox-group-list {
        padding: 20px 0 32px 0;
      }
    }

    .info-btn {
      margin-left: 16px;
      color: #0087FF;
      cursor: pointer;
    }

    .info-reset {
      margin-left: 16px;
      cursor: pointer;
    }
  }

  .footer-btn {
    position: absolute;
    bottom: 0;
    height: 87px;
    border-top: 1px solid #E8ECF2;
    width: calc(100% - 80px);
    display: flex;
    align-items: center;

    .save-btn {
      margin-right: 20px;
    }
  }

  // .icon {
  //     margin: 0 5px;
  //     cursor: pointer;
  // }

  // .selected-products .x-grey-text {
  //     height: 28px;
  //     line-height: 28px;
  // }

  // .el-checkbox {
  //     line-height: 28px;
  // }

  // .tab {
  //     padding: 0 20px 20px 20px;
  // }

  // .x-option-selection {
  //     height: auto;
  //     min-height: auto;
  //     margin-bottom: 20px;
  // }
}
.whitelist{
  width: 60%;
}
</style>
